// import WitnessTokenReceiver from "./WitnessTokenReceiver";

// const App = () => <div><WitnessTokenReceiver /></div>;

// export default App;

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Container } from "react-bootstrap";
import SharedInstancePage from "./pages/SharedInstancePage";
import WitnessedNameAndLogo from "./assets/Witnessed Logo Small.jpg"

function App() {
  return (
    <BrowserRouter>
          {/* Simple Logo Header */}
          <div className="bg-black py-4 shadow-sm">
            <Container className="text-center">
              <a href="https://witnessed.io" target="_blank" rel="noopener noreferrer" className="d-flex align-items-center text-decoration-none" >
                <img
                  src={WitnessedNameAndLogo}
                  alt="Logo"
                  height="50"
                  className="mb-2"
                />
              </a>
            </Container>
          </div>

      <Routes>
        <Route path="/s/:id" element={<SharedInstancePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
